module.exports = "/_next/static/images/text-red-num-2-4062d729.png";